import src from "IMAGE";
export default { src, width: 577, height: 577, blurWidth: 0, blurHeight: 0};
